import { useEffect, useState } from "react";

const Clock = () => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timeInterval = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => clearInterval(timeInterval);
  }, []);

  return (
    <>
      <div className="flex rounded-xl border-4 border-black h-[80px] w-[80px] font-bold text-[40px] leading-none me-2">
        <div className="m-auto pt-3">
          {time.getHours()?.toString()?.length > 1
            ? time.getHours()?.toString()?.charAt(0)
            : 0}
        </div>
      </div>
      <div className="flex rounded-xl border-4 border-black h-[80px] w-[80px] font-bold text-[40px] leading-none">
        <div className="m-auto pt-3">
          {time
            .getHours()
            ?.toString()
            ?.charAt(time.getHours()?.toString()?.length - 1)}
        </div>
      </div>
      <div className="text-[40px] font-bold mx-4">:</div>
      <div className="flex rounded-xl border-4 border-black h-[80px] w-[80px] font-bold text-[40px] leading-none me-2">
        <div className="m-auto pt-3">
          {time.getMinutes()?.toString()?.length > 1
            ? time.getHours()?.toString()?.charAt(0)
            : 0}
        </div>
      </div>
      <div className="flex rounded-xl border-4 border-black h-[80px] w-[80px] font-bold text-[40px] leading-none">
        <div className="m-auto pt-3">
          {time
            .getMinutes()
            ?.toString()
            ?.charAt(time.getMinutes()?.toString()?.length - 1)}
        </div>
      </div>
    </>
  );
};
export default Clock;
